import Form from 'components/Form';

import { Box, Grid, Typography } from '@mui/material';

import { Ti18nId } from 'hooks/useI18n';
import { IFormRegister, IFormValues, IFormWatch } from 'routes/Main/type';

import SectionTitle from '../../components/SectionTitle';

interface Props extends IFormValues, IFormWatch, IFormRegister {
  disabled?: boolean;
  onRequired: (id: Ti18nId) => void;
  onSuccess: (message: string) => void;
}

const checks = [
  {
    label: 'Các triệu chứng niệu đạo như buồn nôn, ói mửa, chán ăn, khác',
    key: 'no3_1.checked1',
  },
  {
    label: 'Tình trạng tâm thần và bệnh não xuống cấp',
    key: 'no3_1.checked2',
  },
  {
    label: 'Viêm tim ngoài tim',
    key: 'no3_1.checked3',
  },
  {
    label: 'Dễ chảy máu',
    key: 'no3_1.checked4',
  },
  {
    label:
      'Khi dịch quá nhiều như phù phổi không được kiểm soát bằng việc sử dụng thuốc',
    key: 'no3_1.checked5',
  },
  {
    label:
      'Tình trạng toan chuyển hóa tăng cường ở những bệnh nhân thiểu niệu hoặc vô niệu',
    key: 'no3_1.checked6',
  },
];

const info = [
  { contents: 'Đông máu và chảy máu' },
  { contents: 'Hạ huyết áp' },
  { contents: 'Hạ thân nhiệt' },
  { contents: 'Sự mất cân bằng chất điện phân và axit-bazơ' },
];

const RecordInfo = (props: Props) => {
  const { disabled, register, getValues, setValue } = props;

  return (
    <>
      <SectionTitle title="3. Mô tả quy trình" />
      <Box sx={{ margin: '48px 0px 30px 20px' }}>
        <Grid container xs={11.8}>
          <Typography sx={{ fontSize: '14px', fontWeight: 500 }}>
            1) Mục đích và hiệu quả của thủ thuật
          </Typography>
          {checks.map((v, i) => {
            return (
              <Grid item xs={11.5}>
                <Form.MuiCheckbox
                  label={v.label}
                  disabled={disabled}
                  defaultValue={Boolean(getValues(v.key)) ? [v.label] : []}
                  onChange={(_, checked) => {
                    setValue(v.key, checked);
                  }}
                />
              </Grid>
            );
          })}
          <Typography
            sx={{ fontSize: '14px', fontWeight: 500, marginTop: '10px' }}
          >
            2) Tác dụng phụ có thể xảy ra
          </Typography>
          {info.map(a => {
            return (
              <Grid item xs={11.5}>
                <Typography sx={{ fontSize: '14px', lineHeight: '30px' }}>
                  • {a.contents}
                </Typography>
              </Grid>
            );
          })}
        </Grid>
        <Typography
          sx={{ margin: '30px 0 20px 0', fontSize: '14px', fontWeight: 500 }}
        >
          Bệnh nhân/người giám hộ đã nghe và hiểu đầy đủ lời giải thích trên về
          liệu pháp thay thế thận liên tục và đồng ý đảm bảo an toàn và điều trị
          cho bệnh nhân.
        </Typography>
      </Box>
    </>
  );
};

export default RecordInfo;
